import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { Doctor } from 'types/doctor';

type DoctorItemModuleProps = {
  doctor: Doctor;
};

const DoctorItemModule: React.FC<DoctorItemModuleProps> = ({ doctor }) => {
  return (
    <ModuleCard
      idLabel={`CRM ${doctor.crm || 'não informado'}`}
      title={doctor.name}
      subtitle={doctor.email}
      status={doctor.formattedActive}
      statusTone={doctor.active ? 'success' : 'error'}
      fields={[
        { label: 'CPF/CNPJ', value: doctor.document_number },
        { label: 'RG', value: doctor.rg },
        { label: 'Telefone', value: doctor.phone },
        { label: 'Estado civil', value: doctor.marital_status },
        { label: 'Cidade/UF', value: [doctor.formattedCity, doctor.formattedState].filter(Boolean).join(' - ') },
      ]}
      onClick={() => history.push(`/doctors/${doctor.id}`)}
    />
  );
};

export default DoctorItemModule;
